module.exports = __webpack_public_path__ + "96eb4711fbf590dcdfd61ee8c8820a86.pdf";